import { useState } from 'react';

export function useInputArray(initialValues: any[] = []) {
  const [values, setValues] = useState(initialValues);

  const addValue = (v) => {
    setValues(() => {
      let arr = [].concat(values);
      arr.push(v);
      return arr;
    });
  };

  const removeValue = (v) => {
    setValues(() => {
      let arr = [].concat(values);
      let i = arr.findIndex((inner) => inner === v);
      arr.splice(i, 1);
      return arr;
    });
  };

  return {
    initialValues,
    values,
    setValues,
    addValue,
    removeValue,
    isModified:
      [].concat(values).sort().join(',') !==
      [].concat(initialValues).sort().join(','),
    reset: () => setValues(null),
    resetInit: () => setValues(initialValues),
  };
}
